import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";

import { AnalyticsClickDirective, ClickAreaDirective } from "@directives";
import { TranslatePipe } from "@pipes";
import { ClientService, CurrencyService } from "@services";

import { ButtonComponent } from "../button/button.component";
import { ModalInstance, ModalWithData } from "../modal/modal.interfaces";
import { ModalService } from "../modal/modal.service";
import { SvgComponent } from "../svg/svg.component";

@Component({
  templateUrl: "./how-to-play-modal.component.html",
  styleUrls: ["./how-to-play-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, SvgComponent, TranslatePipe, ClickAreaDirective, AnalyticsClickDirective],
})
export class HowToPlayModalComponent implements ModalWithData<{}> {
  private readonly clS = inject(ClientService);
  private readonly mS = inject(ModalService);

  public instance: ModalInstance<{}>;

  protected readonly show = signal<boolean>(false);

  protected readonly prefix = inject(CurrencyService).symbol;

  protected close(): void {
    this.clS.set("skipTutorial", this.show());

    this.mS.close(this.instance);
  }

  protected toggle(): void {
    this.show.update(v => !v);
  }
}
